/* eslint-disable max-len */
export default {
  security: [
    {
      id: 102,
      title: "S01E02 | Amber Ashlynn",
      description: "...",
      time: "3 mins",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_1/Episode+2+Amber+Ashlynn/s01e02-thumbnail.png",
      video:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_1/Episode+2+Amber+Ashlynn/1-NINJIO-S1E2-NoSubs-NoQuiz.mp4"
    },
    {
      id: 206,
      title: "S02E06 | My Password is Password",
      description: "...",
      time: "5 mins",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_2/Episode+6+My+Password+is+_Password_/s02e06-thumbnail.png",
      video:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+6+My+Password+is+'Password'/story_content/video_6WQPwx9QDKG_18_56_960x554.mp4"
    },
    {
      id: 301,
      title: "S03E01 | Phishing the Stream",
      description: "...",
      time: "5 mins",
      thumbnail:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+1+Phishing+the+Stream/phishing.jpg",
      video:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+1+Phishing+the+Stream/story_content/video_62pN0GwqyFL_18_56_1202x676.mp4"
    },
  ],
  currentMonthsVideo: [
    {
      id: 605,
      title: "S06E05 | NINJO",
      description: "...",
      time: "5 mins.",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_6/episode_5/605_lockscreen_blank.jpeg",
      video:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_6/episode_5/3-NINJIO-S6E05-Subs-NoQuiz.mp4"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/tour/training/components/catalog_list.js